export let InsApplicationApproval = [
    {prop: 'schemeName', label: '计划名称'},
    {prop: 'orgName', label: '机构名称'},
    {prop: 'provinceName', label: '所属省份', width: '90'},
    {prop: 'commitUserName', label: '提交人'},
    {prop: 'statusText', label: '审批状态', width: '90'},
    {prop: 'rejectCause', label: '驳回原因'},
]

export let accountTableHeader = [
    {prop: 'accountName', label: '账号', width: 250},
    {prop: 'name', label: '账号名称'},
]
  

